<template>
  <component :is="variationComponent" />
</template>

<script>
import { pushToAdobeDataLayer } from '@/js/helpers'

export default {
  name: 'App',

  mounted() {
    pushToAdobeDataLayer(this.componentKey, this.projectConfig.projectId)
  },

  computed: {
    variationComponent() {
      switch (this.componentKey) {
        case 102:
          this.stopBenchmarkResources()
          return 'VariationCg1'
        case 103:
          this.stopBenchmarkResources()
          return 'VariationCg2'
        case 104:
          this.stopBenchmarkResources()
          return 'VariationCg3'
        case 105:
          this.stopBenchmarkResources()
          return 'VariationCg4'
        default:
          return 'BenchmarkCg'
      }
    }
  },
  methods: {
    waitForElement(selector) {
      return new Promise(resolve => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector))
        }
        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector))
            observer.disconnect()
          }
        })
        observer.observe(document.body, {
          childList: true,
          subtree: true
        })
      })
    },
    stopBenchmarkResources() {
      // experiment: prevent benchmark resources from loading in the background
      const mapping = [{ img: 'src' }, { source: 'sourceset' }, { source: 'src' }]
      this.waitForElement('.adt-hidden').then(ele => {
        mapping.forEach(function (map) {
          const key = Object.keys(map)
          ele.querySelectorAll(key).forEach(function (item) {
            item.removeAttribute(map[key])
          })
          ele.querySelectorAll('video').forEach(function (item) {
            item.pause()
            item.load()
          })
        })
      })
    }
  },
  props: {
    componentKey: {
      type: [Number, String],
      default: 0,
      required: true
    },
    projectConfig: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  components: {
    BenchmarkCg: () => import(/* webpackChunkName: "BenchmarkCg" */ './projects/BenchmarkCg'),
    VariationCg1: () => import(/* webpackChunkName: "VariationCg1" */ './projects/VariationCg1'),
    VariationCg2: () => import(/* webpackChunkName: "VariationCg2" */ './projects/VariationCg2'),
    VariationCg3: () => import(/* webpackChunkName: "VariationCg3" */ './projects/VariationCg3'),
    VariationCg4: () => import(/* webpackChunkName: "VariationCg4" */ './projects/VariationCg4')
  }
}
</script>

<style lang="scss">
#sticky {
  bottom: 40px !important;
}
</style>
